/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import styled, { css } from 'styled-components';
import { getNeutralColors, getOrangeColors } from '../theme';
import { ButtonText } from '../typography';
import { Icon } from '../Icon/Icon';

const StyledButton = styled(ButtonText).attrs({
  type: 'button',
  as: 'button'
})`
  display: block;
  padding: 11px 12px;
  border-radius: 40px;
  border: 0;
  ${props =>
    props.size === 100 &&
    css`
      height: 40px;
      width: 40px;
    `}
  ${props =>
    props.size === 200 &&
    css`
      height: 48px;
      width: 48px;
    `}
  ${props =>
    props.border &&
    css`
      border: 1px solid ${getOrangeColors('base')};
    `}
  ${props =>
    props.solid &&
    css`
      background: ${getOrangeColors('base')};
      path {
        fill: ${getNeutralColors('white')};
      }
    `}
  :hover {
    cursor: pointer;
    border-color: ${getOrangeColors('dark')};
    ${props =>
      props.solid &&
      css`
        background: ${getOrangeColors('dark')};
      `}
  }
  :disabled {
    cursor: not-allowed;
    background: ${getNeutralColors('grisClaro')};
    border-color: ${getNeutralColors('grisMedio')};
  }
  :active {
    background: ${getNeutralColors('grisMedioOscuro')};
  }
  :active path {
    fill: ${props => (props.activeIconFill ? props.activeIconFill : getNeutralColors('white')(props))};
  }
`;

const IconButton = props => {
  const { iconName = '', border = false, solid = false, iconFill = '', activeIconFill = '', size = 100 } = props;
  return (
    <StyledButton size={size} border={border} solid={solid} activeIconFill={activeIconFill} {...props}>
      <Icon name={iconName} size={size} svgPathFill={iconFill} margin='0' />
    </StyledButton>
  );
};

export default IconButton;
